common.View.create('shop::Habitats.Website.partials.shop.Product', {

    onDOMLoad() {
        this.initAddToCart();
    },

    initAddToCart() {
        this.element

            // Listen to add to cart button click.
            .find('button[name="addToCart"]:enabled')
                .click(this.onAddToCartClick.bind(this))
                .end();
    },

    async onAddToCartClick() {
        // TODO Low: Enable and fix the 'flash' once the next requests executes super fast?
        // Swal.showLoading();

        // Get product variant
        let variant = this.element.find('button[name="addToCart"]:enabled').data('variant');

        // Request
        let response = await $.post(variant);

        // Update amount in header.
        $('.galaxy\\:\\:habitats-website-layouts-main-Header').data('instance')
            .setTotalPhysicalAmount(response.totalPhysicalAmount);

        // Update mini cart
        $('.shop\\:\\:Habitats-Website-Modules-ShopCheckout-Cart-Partials-MiniCart').data('instance')
            .replaceMiniCart(response.miniCartView, false);

        // TODO Medium: Style
        // Navigate to checkout?
        if ((await Swal.fire({
            title: 'Toegevoegd',
            text: 'Het product is toegevoegd aan je winkelmandje.',
            icon: 'successs',
            showCancelButton: true,
            cancelButtonColor: '#707070',
            cancelButtonText: 'Verder winkelen',
            confirmButtonColor: '#4a7729',
            confirmButtonText: 'Nu afrekenen'
        })).value)
            document.location.href = this.element.data('checkout-url');
    },

});
